import { I18n } from '@calendly/i18n';
import { BodyText, HeadingText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
const containerCss = "c1p9vyoj";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
export const Header = () => <Container>
    <HeadingText level={1} size="medium">
      {I18n.t('publisher.event_types.edit_permissions')}
    </HeadingText>
    <BodyText>
      {I18n.t('publisher.event_types.edit_permissions_modal.description')}
    </BodyText>
  </Container>;

require("./header.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./header.js");